import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
const TableToolbar = ({ className, children }) => (_jsx("div", Object.assign({ className: classNames('table-toolbar', className) }, { children: children })));
export default TableToolbar;
